import { ReactNode } from "react";
import { Button } from '@mui/material';
import { CancelRounded as CancelRoundedIcon } from '@mui/icons-material';
import CSS from 'csstype';

import { useTrans } from "~/hooks/useTrans";

import "./style.less";

export interface IMyListItem {
	id: number;
	title: string;
}

interface IMyList {
	items: Array<IMyListItem>;
	sx?: CSS.Properties;
	onRemove?: (item: IMyListItem) => void;
	startIcon?: ReactNode;
	endIcon?: ReactNode;
}

export default function MyList({
	items = [],
	sx = {},
	onRemove = () => {},
	startIcon = null,
	endIcon = <CancelRoundedIcon sx={{ color: "var(--dark-green-text-color)" }} />,
}: IMyList) {
	const { trans } = useTrans();
	const buttonSx = {
		background: "var(--active-background)",
		color: "var(--black-text-color)",
		textTransform: "none",
		...endIcon === null
			? {
				cursor: "default",
			}
			: {},
	};

	return <div className="myList" style={sx}>
		{ items.map(item => <Button variant="outlined" startIcon={startIcon} endIcon={endIcon} disableRipple={endIcon === null} sx={buttonSx} key={item.id} onClick={() => onRemove(item)}>
			{ item.title }
		</Button>) }
		{ items.length === 0 && <span>{ trans("emptyList") }</span> }
	</div>;
}
